import Vue from 'vue';
import VueRouter from 'vue-router';
import Cookies from 'js-cookie';
import vueDebounce from 'vue-debounce';
import AppLogo from './components/AppLogo';
import Store from './signup/shared/store';
import axios from 'axios';


/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */
require('./app/bootstrap');

window.Vue = require('vue').default;

window.Vue.use(vueDebounce);
window.Cookies = Cookies;
window.Vue.use(VueRouter);

/**
 * Next, we will dynamically load the appropriate version of routes and store
 * based on the file structure.
 */
let Routes;

// Determine which version to load based on nova setting
const version = window.organic_sign_up_version;

// Dynamically import routes and store based on the version
Promise.all([
    import(`./signup/${version}/routes`),
]).then(([routesModule]) => {
    Routes = routesModule.default;

    // Create Vue application instance after dynamic imports have resolved
    createApp();

    handleMailCampaignUser();
});

/**
 * Function to handle mail campaign user
 */
function handleMailCampaignUser() {
    if (window.mailCampaignUser) {

        console.log('UPDATING MAIL CAMPAIGN USER', window.mailCampaignUser);

        Store.commit('updateContact', { key: 'first_name', value: window.mailCampaignUser.first_name });
        Store.commit('updateContact', { key: 'last_name', value: window.mailCampaignUser.last_name });
        Store.commit('updateContact', { key: 'mail_campaing_user_token', value: window.mailCampaignUser.token });
        Store.commit('updateContact', { key: 'address', value: window.mailCampaignUser.full_street_address });
        Store.commit('updateContact', { key: 'city', value: window.mailCampaignUser.city });
        Store.commit('updateContact', { key: 'state', value: window.mailCampaignUser.state });
        Store.commit('updateContact', { key: 'zip', value: window.mailCampaignUser.zip_code });
        Store.dispatch('updateContact', { key: 'birth_day', value: window.mailCampaignUser.birth_day });
        Store.dispatch('updateContact', { key: 'birth_month', value: window.mailCampaignUser.birth_month });
        Store.dispatch('updateContact', { key: 'birth_year', value: window.mailCampaignUser.birth_year });
        Store.commit('updateContact', { key: 'date_of_birth', value: window.mailCampaignUser.raw_dob });
        Store.commit('updateContact', { key: 'phone_number', value: window.mailCampaignUser.phone_number });
        

        Store.commit('updateContact', { key: 'contact_email', value: window.mailCampaignUser.email });
        Store.commit('updateLoan', { key: 'amount', value: window.mailCampaignUser.amount });
    }
}

/**
 * Function to create Vue application instance
 */
function createApp() {
    const router = new VueRouter({
        mode: 'history',
        base: 'signup',
        routes: Routes,
        scrollBehavior(to, from, savedPosition) {
            return { x: 0, y: 0 };
        }
    });

    router.beforeEach((to, from, next) => {
        if (from.name === null) {
            // Here we reset the errors state from any requests, on a clean page load.
            Store.dispatch('resetErrorsToBaseState');
            
            // Check for VPN on initial page load
            checkForVpn();
        }

        if (to.name) {
            let event = {
                event: `loaded-${to.name}`
            };

            console.log(event);

            if (window.dataLayer !== undefined) {
                window.dataLayer.push(event);
            }

            Store.dispatch('saveImpression');
        }

        next();
    });

    // Global VPN detection function
    function checkForVpn() {
        window.grecaptcha?.ready(() => {
            window.grecaptcha.execute(window.recaptchaV3Sitekey, { action: 'vpnDetection' })
                .then(token => {
                    if (token) {
                        axios.get('/user-risk-check', {
                            params: {
                                recaptcha: token,
                                get_vpn_info: true
                            }
                        })
                        .then(response => {
                            if (response.data && (response.data.is_vpn)) {
                                Store.commit('setVpnDetected', true);
                                app.$emit('vpn-detected');
                            } else {
                                Store.commit('setVpnDetected', false);
                            }
                        })
                        .catch(error => {
                            console.error('VPN check failed:', error);
                        });
                    }
                });
        });
    }

    const app = new Vue({
        router,
        store: Store,

        comments: {
            AppLogo
        },

        created() {
            this.app = {
                ...window.app,
                mailtoSupport: `mailto:${window.app.support_email}`,
            };
        }
    }).$mount('#app');
}
